import NoveltiesPage from './NoveltiesPage';

import './novelties.scss';

export default NoveltiesPage;